import { env } from 'cloudflare:workers';
import { createServerFn } from '@tanstack/react-start';
import { createFileRoute } from '@tanstack/react-router';
import css from '@photology/ui/theme.css?url';
import PuckEditor from '~/editor/PuckEditor';
import { type SerializedPuckData } from '~/editor/SerializedPuckData';

const getMicrositePuck = createServerFn()
	.inputValidator((data: { id: string }) => data)
	.handler(async ({ data }): Promise<SerializedPuckData> => {
		const actor = env.MicrositeDurableObject.getByName(data.id);

		return actor.getEditorPuck();
	});

const saveMicrositePuck = createServerFn({ method: 'POST' })
	.inputValidator((data: { id: string; puck: SerializedPuckData }) => data)
	.handler(async ({ data }) => {
		const actor = env.MicrositeDurableObject.getByName(data.id);

		await actor.saveLivePuck(data.puck);
	});

export const Route = createFileRoute('/id/$id/edit')({
	loader: async ({ params }) => {
		return await getMicrositePuck({ data: { id: params.id } });
	},
	component: EditMicrositeRoute,
	head: () => ({
		links: [{ rel: 'stylesheet', href: css }],
	}),
});

function EditMicrositeRoute() {
	const { id } = Route.useParams();

	return (
		<PuckEditor
			initialData={Route.useLoaderData()}
			onPublish={(puck) => {
				void saveMicrositePuck({ data: { id, puck } });
			}}
		/>
	);
}
